<template>
  <div
    class="card chart-card"
    style="height: 315px; border-radius: 8px; margin-bottom: 20px"
  >
    <!-- style="height: 283px" -->
    <div class="d-flex card-header portfolioPerformanceChartTitle">
      <div class="dashboard-cards-header">
        <el-select
          class="dashboardPerformanceDropdown dashboardCategoryDropdown-el-select dashboardCategoryDropdown1 select-primary"
          size="small"
          placeholder
          @change="categoryChange"
          v-model="category.selected"
        >
          <el-option
            v-for="option in categoryDropdown"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </div>
      <div
        style="margin-top: auto; margin-bottom: auto"
        v-tooltip.top-end="toolTipInfo"
      >
        <img src="static/img/graphInfo.svg" class />
      </div>
    </div>
    <div class="portfolioPerformanceChart">
      <div v-if="category.selected == 'top' || category.selected == 'least'">
        <div v-if="activeCompanies.data.length > 0">
          <table class="portfolioPerformanceTable w-100">
            <tr class="portfolioPerformanceTableHeading">
              <th>COMPANY NAME</th>
              <th style="text-align: center">GAIN</th>
              <th style="text-align: center">Multiple</th>
            </tr>
            <tr
              v-for="field in activeCompanies.data"
              :key="field._id"
              class="portfolioPerformanceTableLoop"
            >
              <td
                style="color: #5445f3; cursor: pointer"
                class="portfolioPerformanceTableTd"
                @click="navigateToProfile(field)"
              >
                {{ field.name }}
              </td>
              <td style="text-align: center" v-if="field.gain_loss >= 0">
                ${{ formatNumberWithComma(field.gain_loss) }}
              </td>
              <td style="text-align: center" v-if="field.gain_loss < 0">
                -${{ formatNumberWithComma(field.gain_loss * -1) }}
              </td>
              <td style="text-align: center">{{ field.multiple }}</td>
            </tr>
          </table>
        </div>
        <div v-else class="w-100">
          <div style="justify-content: center; display: flex; color: #707070">
            No records to view
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row mr-0 ml-0">
          <div class="col-6">
            <chartjs-pie
              :chart-data="ceoChartData"
              :options="ceoChartOptions"
              :styles="pieChartStyle"
            ></chartjs-pie>
          </div>
          <div class="col-6">
            <chartjs-pie
              :chart-data="founderChartData"
              :options="founderChartOptions"
              :styles="pieChartStyle"
            ></chartjs-pie>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import { mapGetters } from "vuex";
import _ from "lodash";
import ChartjsPie from "../../components/Chartjs/ChartjsPie";
import { formatNumberWithComma } from "../../util";
export default {
  name: "portfolioPerformanceTable",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    ChartjsPie,
  },
  data() {
    return {
      category: {
        selected: "top",
      },
      ceoDataSets: [],
      ceoLabels: [],
      founderDataSets: [],
      founderLabels: [],
      founderTextCenterLabel: [],
      ceoTextCenterLabel: [],
    };
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioData"]),
    ...mapGetters("charts", ["genderChartData"]),
    categoryDropdown() {
      let dropDownArray = [];
      dropDownArray[0] = { label: "Top Performing Companies", value: "top" };
      dropDownArray[1] = {
        label: "Least Performing Companies",
        value: "least",
      };
      dropDownArray[2] = {
        label: "Portfolio Composition",
        value: "gender",
      };
      return dropDownArray;
    },
    activeCompanies() {
      // top 10 not out of business sorted by value
      let values = _.filter(this.portfolioData, (pd) => {
        if (
          pd.data_status.toLowerCase() != "unconfirmed" &&
          pd.data_status.toLowerCase() != "nocompanyurl"
        ) {
          if (pd.status && pd.status.toLowerCase() != "out of business") {
            return pd;
          } else {
            if (!pd.status) {
              return pd;
            }
          }
        }
        // return (
        //   pd &&
        //   typeof pd.status === "string" &&
        //   pd.status.toLowerCase() != "out of business" &&
        //   pd.data_status.toLowerCase() != "unconfirmed"
        // );
      });
      values = _.map(values, (data) => {
        data["multiple"] = this.computeMultiple(data);
        data["gain_loss"] = this.computeGainLoss(data);
        data["status"] = data["status"] ? data["status"] : "Unknown";
        // data["last_funding_round"] = data["last_funding_round"]
        //   ? moment(data["last_funding_round"]).format("MM/DD/YYYY")
        //   : "missing date";
        return data;
      });
      values = _.sortBy(values, [
        function (pd) {
          return -pd.gain_loss;
        },
      ]);
      let data = values.slice(0, 10);
      let loopData = {};
      loopData.top = values.length >= 5 ? values.slice(0, 5) : values;
      if (values.length >= 10) {
        loopData.least = values.slice(values.length - 5, values.length);
      }
      if (values.length > 5 && values.length < 10) {
        loopData.least = values.slice(5, values.length);
      }
      if (values.length <= 5) {
        loopData.least = [];
      }
      return {
        data: loopData[this.category.selected],
        placeholder: "No records to view",
      };
    },
    ceoChartData() {
      const self = this;
      let data = {
        labels: _.flatten(self.computedCeoLabels),
        datasets: self.computedCeoDataset,
      };
      return data;
    },
    founderChartData() {
      const self = this;
      let founderData = {
        labels: _.flatten(self.computedFounderLabels),
        datasets: self.computedFounderDataset,
      };
      return founderData;
    },
    ceoChartOptions() {
      const self = this;
      // let d = self.chartData
      let options = {
        cutoutPercentage: 60,
        title: {
          display: true,
          text: "CEO of companies",
          fontSize: 12,
          fontFamily: "custom-helvetica-medium",
          fontColor: "#30334C",
          position: "bottom",
        },
        plugins: {
          doughnutlabel: {
            labels: self.ceoTextCenterLabel,
          },
        },
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].header_label[
                  toolTipItem.index
                ] || "") +
                ": " +
                (data.datasets[toolTipItem.datasetIndex].data[
                  toolTipItem.index
                ] || "") +
                "%"
              );
            },
            footer: function (toolTips, data) {
              let toolTipItem = toolTips[0];
              let value =
                data.datasets[toolTipItem.datasetIndex].data_value[
                  toolTipItem.index
                ] || 0;
              return value > 1 ? `${value} Companies` : `${value} Company`;
            },
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
            padding: 15,
          },
        },
      };
      return options;
    },
    founderChartOptions() {
      const self = this;
      // let d = self.chartData
      let options = {
        cutoutPercentage: 60,
        title: {
          display: true,
          text: "Founding team",
          fontSize: 12,
          fontFamily: "custom-helvetica-medium",
          fontColor: "#30334C",
          position: "bottom",
        },
        plugins: {
          doughnutlabel: {
            labels: self.founderTextCenterLabel,
          },
        },
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].header_label[
                  toolTipItem.index
                ] || "") +
                ": " +
                (data.datasets[toolTipItem.datasetIndex].data[
                  toolTipItem.index
                ] || "") +
                "%"
              );
            },
            footer: function (toolTips, data) {
              let toolTipItem = toolTips[0];
              let value =
                data.datasets[toolTipItem.datasetIndex].data_value[
                  toolTipItem.index
                ] || 0;
              return value > 1 ? `${value} Companies` : `${value} Company`;
            },
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
            padding: 15,
          },
        },
      };
      return options;
    },
    computedCeoDataset() {
      return this.ceoDataSets;
    },
    computedCeoLabels() {
      return this.ceoLabels;
    },
    computedFounderDataset() {
      return this.founderDataSets;
    },
    computedFounderLabels() {
      return this.founderLabels;
    },
    pieChartStyle() {
      return {
        //height: "300px",
        position: "relative",
      };
    },
    toolTipInfo() {
      if (this.category.selected == "top") {
        return "Shows the top performing companies in your portfolio with the highest value minus cost ratio";
      } else if (this.category.selected == "least") {
        return "Shows the least perfoming companies with lower values minus cost ratio";
      } else {
        let returnValue =
          '<div style="font-size:14px">Left chart: Shows how many of your portfolio companies have a female CEO. <br/>Right chart: Shows if there is a female in the founding team of a specific company</div>';
        return returnValue;
      }
    },
  },
  methods: {
    categoryChange() {
      if (
        this.category.selected == "top" ||
        this.category.selected == "least"
      ) {
        this.activeCompanies;
      } else {
        this.createPrimaryDataset();
      }
    },
    computeMultiple(data) {
      return data.cost &&
        data.value &&
        Number(data.cost) > 0 &&
        Number(data.value) > 0
        ? (Number(data.value) / Number(data.cost)).toFixed(2)
        : 0;
    },
    computeGainLoss(data) {
      return data.value >= 0 && data.cost >= 0 ? data.value - data.cost : 0;
    },
    createPrimaryDataset() {
      const self = this;
      // do initial calculate for chart data
      let ceoLabels = [];
      let ceoBackgroundColors = [];
      let ceoValues = [];
      let ceoValues_p = [];
      let ceoTotalLength = 0;
      let founderLabels = [];
      let founderBackgroundColors = [];
      let founderValues = [];
      let founderValues_p = [];
      let founderTotalLength = 0;
      self.founderTextCenterLabel = [];
      self.ceoTextCenterLabel = [];
      if (
        self.genderChartData &&
        self.genderChartData.ceo &&
        self.genderChartData.ceo.male
      ) {
        ceoTotalLength = self.genderChartData.ceo.female
          ? self.genderChartData.ceo.male + self.genderChartData.ceo.female
          : self.genderChartData.ceo.male;
        ceoLabels.push("Male");
        ceoValues.push(self.genderChartData.ceo.male);
        ceoValues_p.push(
          ((self.genderChartData.ceo.male / ceoTotalLength) * 100).toFixed(2)
        );
        //ceoBackgroundColors.push("#451EEF");
        ceoBackgroundColors.push("#6771dc");
        let ceoTextCenterLabel = `Male - ${(
          (self.genderChartData.ceo.male / ceoTotalLength) *
          100
        ).toFixed(2)}%`;
        let obj = {
          text: ceoTextCenterLabel,
          font: {
            size: "12",
            family: "custom-helvetica-medium,roboto",
          },
          color: "#050505",
        };
        self.ceoTextCenterLabel.push(obj);
      }
      if (
        self.genderChartData &&
        self.genderChartData.ceo &&
        self.genderChartData.ceo.female
      ) {
        ceoTotalLength = self.genderChartData.ceo.male
          ? self.genderChartData.ceo.male + self.genderChartData.ceo.female
          : self.genderChartData.ceo.female;
        ceoLabels.push("Female");
        ceoValues.push(self.genderChartData.ceo.female);
        ceoValues_p.push(
          ((self.genderChartData.ceo.female / ceoTotalLength) * 100).toFixed(2)
        );
        // ceoBackgroundColors.push("#FF6969");
        ceoBackgroundColors.push("#c767dc");
        let ceoTextCenterLabel = `Female - ${(
          (self.genderChartData.ceo.female / ceoTotalLength) *
          100
        ).toFixed(2)}%`;
        let obj = {
          text: ceoTextCenterLabel,
          font: {
            size: "12",
            family: "custom-helvetica-medium,roboto",
          },
          color: "#050505",
        };
        self.ceoTextCenterLabel.push(obj);
      }
      if (
        self.genderChartData &&
        self.genderChartData.founder &&
        self.genderChartData.founder.male
      ) {
        founderTotalLength = self.genderChartData.founder.female
          ? self.genderChartData.founder.male +
            self.genderChartData.founder.female
          : self.genderChartData.founder.male;
        founderLabels.push("Male");
        founderValues.push(self.genderChartData.founder.male);
        founderValues_p.push(
          (
            (self.genderChartData.founder.male / founderTotalLength) *
            100
          ).toFixed(2)
        );
        //founderBackgroundColors.push("#451EEF");
        founderBackgroundColors.push("#6771dc");
        let founderTextCenterLabel = `Male - ${(
          (self.genderChartData.founder.male / founderTotalLength) *
          100
        ).toFixed(2)}%`;
        let obj = {
          text: founderTextCenterLabel,
          font: {
            size: "12",
            family: "custom-helvetica-medium,roboto",
          },
          color: "#050505",
        };
        self.founderTextCenterLabel.push(obj);
      }
      if (
        self.genderChartData &&
        self.genderChartData.founder &&
        self.genderChartData.founder.female
      ) {
        founderTotalLength = self.genderChartData.founder.male
          ? self.genderChartData.founder.male +
            self.genderChartData.founder.female
          : self.genderChartData.founder.female;
        founderLabels.push("Female");
        founderValues.push(self.genderChartData.founder.female);
        founderValues_p.push(
          (
            (self.genderChartData.founder.female / founderTotalLength) *
            100
          ).toFixed(2)
        );
        // founderBackgroundColors.push("#FF6969");
        founderBackgroundColors.push("#c767dc");
        let founderTextCenterLabel = `Female - ${(
          (self.genderChartData.founder.female / founderTotalLength) *
          100
        ).toFixed(2)}%`;
        let obj = {
          text: founderTextCenterLabel,
          font: {
            size: "12",
            family: "custom-helvetica-medium,roboto",
          },
          color: "#050505",
        };
        self.founderTextCenterLabel.push(obj);
      }
      self.ceoDataSets = [];
      self.ceoLabels = [];
      self.ceoLabels = ceoLabels;
      self.ceoDataSets.push({
        header_label: ceoLabels,
        data: ceoValues_p,
        data_value: ceoValues,
        backgroundColor: ceoBackgroundColors,
      });
      self.founderDataSets = [];
      self.founderLabels = [];
      self.founderLabels = founderLabels;
      self.founderDataSets.push({
        header_label: founderLabels,
        data: founderValues_p,
        data_value: founderValues,
        backgroundColor: founderBackgroundColors,
      });
    },
    navigateToProfile(item) {
      let self = this;
      if (item.ucid) {
        self.$store.commit("temp/currentCompany", item.ucid);
        self.$router.push(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${item.ucid}`
        );
      }
    },
    formatNumberWithComma,
  },
  mounted() {
    this.categoryChange();
    let self = this;
    this.$store
      .dispatch("charts/getGenderChartData")
      .then((data) => {
        if (self.genderChartData) {
          self.createPrimaryDataset();
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  },
  watch: {
    genderChartData: {
      handler(newData) {
        // updated portfolio, run update
        if (newData) this.createPrimaryDataset();
      },
    },
    $route(to, from) {
      this.category.selected = "top";
    },
  },
};
</script>
<style>
.dashboardPerformanceDropdown .el-input {
  width: 270px !important;
  /* width: 365px !important; */
}
.portfolioPerformanceTableHeading {
  border-bottom: 1px solid #707070;
}
.portfolioPerformanceTableLoop {
  border-bottom: 1px solid rgba(112, 112, 112, 0.09);
}
.portfolioPerformanceTableTd:hover {
  text-decoration: underline;
}
</style>